const SELECTOR = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
].join(",");

export function focusables(root: HTMLElement): HTMLElement[] {
  return Array.from(root.querySelectorAll<HTMLElement>(SELECTOR)).filter(
    (el) => el.offsetParent !== null && !el.hasAttribute("aria-hidden"),
  );
}

export function autoFocus(root: HTMLElement): void {
  setTimeout(() => focusables(root)[0]?.focus(), 0);
}

export function trapTab(event: KeyboardEvent, root: HTMLElement, reverse: boolean): void {
  const list = focusables(root);
  if (list.length === 0) return;
  const first = list[0];
  const last = list[list.length - 1];
  const active = document.activeElement as HTMLElement | null;
  if (reverse && (active === first || !root.contains(active))) {
    event.preventDefault();
    last.focus();
  } else if (!reverse && (active === last || !root.contains(active))) {
    event.preventDefault();
    first.focus();
  }
}
